 <div *ngIf="configuration">

  <h4 style="margin-left: 20px;">{{"SingleWorkOrder" | translate}}</h4>

  <ct-model  [configuration]="configuration"></ct-model>

</div>

<div *ngIf="workOrderList.length > 0" class="work-order-list">
  <mat-card *ngFor="let workOrder of workOrderList" class="work-order-card">
    <mat-card-content>
      <p><strong>{{"WorkOrder" | translate}}:</strong>{{ workOrder.Name }}</p>
      <p><strong>{{"Code"|translate}}:</strong> {{ workOrder.Code }}</p>
      <p *ngIf="workOrder.Address"><strong>{{"Address" | translate}}:</strong> {{ workOrder.Address }}</p>
      <p *ngIf="workOrder.CompanyVAT"><strong>{{"COMPANYVAT" | translate}}:</strong> {{ workOrder.CompanyVAT }}</p>
      <p *ngIf="workOrder.Description"><strong>{{"Description" | translate}}:</strong> {{ workOrder.Description }}</p>
      <p *ngIf="workOrder.Company.ReferenceName"><strong>{{"Customer" | translate}}:</strong> {{ workOrder.Company.ReferenceName }}</p>

    </mat-card-content>
    <mat-card-actions>
      <ct-button [configuration]="buttonConfiguration"></ct-button>
    </mat-card-actions>
  </mat-card>
</div>
